import { NavLink } from "react-router";
import "./Header.css";
import { useContext } from "react";
import { UserContext } from "../../contexts/UserContext";

function Header() {
    const userContext = useContext(UserContext);

    return (
        <header className="basic-layout-header">
            <h1 className="basic-layout-title">Monstarbay</h1>
            <nav className="basic-layout-nav">
                <ul>
                    <li><NavLink to="/">Home</NavLink></li>
                    {userContext?.loggedIn && <li><NavLink to="/account">Account</NavLink></li>}
                    <li><NavLink to="/privacy">Privacy</NavLink></li>
                </ul>
            </nav>
        </header>
    );
}

export default Header;